import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../../app.json";
import { ReadData } from "../../../../providers/Patient.Provider";
import NewLeaveForm from "./NewLeave";
import LeaveList from "./LeaveList";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { LIST, CREATE, UPDATE } from "../../../../queries/leave.query";
import auth from "../../../../providers/Auth.Provider";
import LoadingSpinner from "../../../../partials/loading";
import AlertMessage from "../../../../partials/alertMessage";
import LeaveDetail from "./LeaveDetail";
import UpdateLeaveForm from "./UpdateLeave";
import { toast } from "react-toastify";
import { EventEmitter } from "../../../../event/EventEmitter";
import { EVENT_TARGET, ACTION_TYPE } from "../../../../event/model";
import { sendNotification } from "../../../../sockette";

const Leave = () => {
    const [newLeave, setNewLeave] = useState(false);
    const [vLeave, setVLeave] = useState(null);
    const [eLeave, setELeave] = useState(null);

    const patient = ReadData();
    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
    const { site } = GetToken() && GetAuthenticatedStaff();
    // List Query
    const { loading, data, refetch } = useQuery(LIST, {
        variables: { site: site && site.id, id: patient.lastAdmission },
        onError: (e) => toast.error(e.message),
        notifyOnNetworkStatusChange: true,
    });
    // Update
    const [updateFunc, { loading: uLoading, data: uData }] = useMutation(UPDATE, {
        onError: (e) => toast.error(e.message),
        onCompleted: (d) => {
            const { message } = d.UpdateBasicLeave;
            toast.success(message);
            sendNotification(message, ACTION_TYPE.UPDATE, EVENT_TARGET.LEAVE);
        },
    });
    // New
    const [PostCreateFunc, { loading: cLoading, error: cError, data: cData }] = useMutation(CREATE, {
        onError: (e) => toast.error(e.message),
        onCompleted: (d) => {
            const { message } = d.CreateLeave;
            toast.success(message);
            sendNotification(message, ACTION_TYPE.CREATE, EVENT_TARGET.LEAVE);
        },
    });

    if (patient && !patient.lastAdmission)
        return (
            <div className="text-center">
                <h2 className="text-pink">Feature can only be used for in-patient only!</h2>
            </div>
        );
    function scrollTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    EventEmitter.subscribe(EVENT_TARGET.LEAVE, () => refetch());

    return (
        <>
            <Helmet>
                <title>Patient Leave | {appName}</title>
            </Helmet>
            <div className="row justify-content-center">
                {newLeave && !vLeave && !eLeave && (
                    <div className="col-md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewLeave(false);
                                            setELeave(null);
                                            setVLeave(null);
                                            scrollTop();
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    New Leave Form
                                </header>
                            </div>
                            <div className="card-body m-b-20">
                                <LoadingSpinner loading={cLoading} />
                                <AlertMessage message={cError && cError.message} failed={true} />
                                <AlertMessage message={cData && cData.CreateLeave.message} />
                                <NewLeaveForm
                                    types={data && data.GetLeaveTypes.docs}
                                    escorts={data && data.GetStaffList.docs}
                                    statusList={data && data.GetLeaveStatusList.docs}
                                    onCancel={() => setNewLeave(false)}
                                    onSubmit={async (item) => {
                                        await PostCreateFunc({
                                            variables: {
                                                model: {
                                                    ...item,
                                                    admission: patient.lastAdmission,
                                                },
                                            },
                                        });
                                        setTimeout(() => setNewLeave(false), 500);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {!newLeave && !vLeave && !eLeave && (
                    <div className="col-md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>Patient Leave</header>
                                <div className="float-right mt-2 mr-2">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setNewLeave(true);
                                            setELeave(null);
                                            setVLeave(null);
                                            scrollTop();
                                        }}
                                        className="mdl-button fade-in mdl-button--raised mdl-js-ripple-effect m-b-10 btn-primary btn-circle"
                                    >
                                        <i className="material-icons">add</i> New Leave
                                    </button>
                                </div>
                            </div>
                            <div className="card-body" style={{ minHeight: "450px" }}>
                                <LoadingSpinner loading={loading} />
                                {!loading && (
                                    <LeaveList
                                        items={data && data.GetAdmissionLeaves.docs}
                                        onView={(l) => {
                                            setVLeave(l);
                                            scrollTop();
                                            setNewLeave(false);
                                            setELeave(null);
                                        }}
                                        onEdit={(item) => {
                                            setELeave(item);
                                            setVLeave(null);
                                            setNewLeave(false);
                                            scrollTop();
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {!newLeave && vLeave && !eLeave && (
                    <div className="col-md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setELeave(null);
                                            setNewLeave(false);
                                            setVLeave(null);
                                            scrollTop();
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    Leave Detail
                                </header>
                            </div>
                            <div className="card-body">
                                <LeaveDetail
                                    item={vLeave}
                                    onEdit={(item) => {
                                        setELeave(item);
                                        setNewLeave(false);
                                        setVLeave(null);
                                        scrollTop();
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {!newLeave && !vLeave && eLeave && (
                    <div className="col-md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setELeave(null);
                                            setNewLeave(false);
                                            setVLeave(null);
                                            scrollTop();
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    Update Leave
                                </header>
                            </div>
                            <div className="card-body">
                                <LoadingSpinner loading={uLoading} />
                                <AlertMessage message={uData && uData.UpdateBasicLeave.message} />
                                <UpdateLeaveForm
                                    item={eLeave}
                                    onSubmit={async (update) => {
                                        scrollTop();
                                        const { id, ...model } = update;
                                        await updateFunc({
                                            variables: { id, model },
                                        });
                                        setVLeave(null);
                                        setELeave(null);
                                    }}
                                    onCancel={() => {
                                        setELeave(null);
                                        setNewLeave(false);
                                        setVLeave(null);
                                        scrollTop();
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Leave;
